export default __webpack_public_path__ + "static/media/day3_pitch.06198365.jpg";